import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export const getUserById = async (user_id: number, userRole?: string): Promise<UserProfile> => {
  const id = Number(user_id);
  if (!Number.isFinite(id)) {
    return Promise.reject(new Error('getUserById: invalid user id'));
  }
  const prefix =
    userRole === 'CareAdvisor' ? '/care_advisor' : userRole === 'Collector' ? '/collector' : '/admin';
  const { data } = await client.get(`${prefix}/users/${id}`);

  return data;
};
